<script setup lang="ts">
import { Skeleton } from 'ant-design-vue';

interface ParagraphProps {
  rows?: number;
  width?: number | string | Array<number | string>;
}
interface Props {
  active?: boolean;
  loading: boolean;
  avatar?: boolean;
  paragraph?: boolean | ParagraphProps;
  title?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  active: true,
  avatar: false,
  paragraph: () => ({ rows: 4 }),
  title: true,
});
</script>

<template>
  <div>
    <Skeleton
      :active="props.active"
      :loading="props.loading"
      :avatar="props.avatar"
      :paragraph="props.paragraph"
      :title="props.title"
    >
      <slot></slot>
    </Skeleton>
  </div>
</template>

<style scoped></style>
